// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8b01e2d7","395":"5a14981e","396":"4e33bf41","408":"2d507bbb","455":"5d8709e8","977":"02b4d876"}[chunkId] + ".chunk.js";
};